'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.createAgent = createAgent;
exports.default = fetchJSON;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

require('isomorphic-fetch');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _tunnelAgent = require('tunnel-agent');

var _tunnelAgent2 = _interopRequireDefault(_tunnelAgent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import clc from 'cli-color';

var MAX_SOCKET_SIZE = Infinity;

var stringify = function stringify(values) {
  return _lodash2.default.map(values, function (value, key) {
    if (value === undefined || value === null) {
      return '';
    }

    if (key === 'para' || key === 'callback') {
      return key + '=' + value;
    }

    if (value === '') {
      return '';
    }

    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).filter(function (value) {
    return value;
  }).concat(['applicationId=rakuten_travel_front_end']).join('&');
};

var getHeader = function getHeader(req) {
  var headers = {
    'Content-Type': 'text/plain'
  };

  if (req) {
    headers.cookie = req.cookie;
  }

  return {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
};

var postHeader = function postHeader(values, req) {
  var postType = 'json';
  var headers = {};

  if (req) {
    headers.cookie = req.cookie;
  }

  (0, _keys2.default)(values).forEach(function (key) {
    if (values[key] instanceof File) {
      postType = 'file';
    }
  });

  switch (postType) {
    case 'file':
      {
        var _ret = function () {
          var body = new FormData();
          (0, _keys2.default)(values).forEach(function (key) {
            var item = values[key];
            if (item instanceof File) {
              body.append(key, item, item.name);
            } else {
              body.append(key, item);
            }
          });
          return {
            v: {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: body
            }
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
      }
    default:
      headers['Content-Type'] = 'text/plain';
      return {
        method: 'POST',
        mode: 'cors',
        headers: headers,
        body: (0, _stringify2.default)(values)
      };
  }
};

var deleteHeader = function deleteHeader(values, req) {
  var headers = {
    'Content-Type': 'text/plain'
  };

  if (req) {
    headers.cookie = req.cookie;
  }

  return {
    method: 'DELETE',
    mode: 'cors',
    headers: headers,
    body: (0, _stringify2.default)(values)
  };
};

var getDefaultErrors = function getDefaultErrors(messages) {
  return {
    maintenance: {
      errors: [{
        code: 'SERVICE_UNAVALIABLE',
        title: messages.maintenance ? messages.maintenance.title : 'Service unavailable',
        message: messages.maintenance ? messages.maintenance.message : 'Service unavailable'
      }]
    },
    timeout: {
      errors: [{
        code: 'SERVICE_UNAVALIABLE',
        title: messages.timeout ? messages.timeout.title : 'Service unavailable',
        message: messages.timeout ? messages.timeout.message : 'Service unavailable'
      }]
    }
  };
};

function constructTunnelFnName(uri, proxy) {
  var parsedProxy = _url2.default.parse(proxy);
  return ['https', // NEED INVESTIGATION: Event if target protocal is http, we should use https to create tunnel
  parsedProxy.protocol === 'https:' ? 'Https' : 'Http'].join('Over');
}

function constructHost(uriObject) {
  var port = uriObject.port;
  var protocol = uriObject.protocol;
  var host = uriObject.hostname;

  return port ? host + ':' + port : protocol === 'https:' ? host + ':443' : host + ':80';
}

function constructTunnelOptions(uri, proxy) {
  var parsedUri = _url2.default.parse(uri);
  var parsedProxy = _url2.default.parse(proxy);
  return {
    // maxSockets default size is 5, it is too small to access API in parallel and comes user in same time.
    maxSockets: MAX_SOCKET_SIZE,
    proxy: {
      host: parsedProxy.hostname,
      port: +parsedProxy.port,
      proxyAuth: parsedProxy.auth,
      headers: { host: constructHost(parsedUri) }
    },
    headers: { host: parsedUri.hostname },
    rejectUnauthorized: false
  };
}

function createAgent(url, proxy) {
  var tunnelFnName = constructTunnelFnName(url, proxy);
  var tunnelOptions = constructTunnelOptions(url, proxy);
  return _tunnelAgent2.default[tunnelFnName](tunnelOptions);
}

// TODO: errors should be rejected with a concise format
//       to be defined after API definition completes
// TODO: Change parameters to object parameters or Change function to contructor to ommit many same arguments
function fetchJSON() {
  var originalUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var req = arguments[3];
  var messages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var timeout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 20000;
  var retrieveBracket = arguments[6];

  var removedProtocollUrl = '';
  if (__SERVER__ && !req) {
    return _promise2.default.reject({ errors: [{ message: 'API client required to have req parameter in Server' }] });
  }
  if (!__SERVER__ && _url2.default.parse(originalUrl).hostname === location.hostname) {
    removedProtocollUrl = originalUrl.replace(/^https?:/, '');
  }
  var defaultErrors = getDefaultErrors(messages);
  var apiUrl = method === 'GET' ? [removedProtocollUrl || originalUrl, stringify(values)].filter(function (value) {
    return value;
  }).join('?') : removedProtocollUrl || originalUrl;
  var headers = method === 'GET' ? getHeader(req) : method === 'POST' ? postHeader(values, req) : method === 'DELETE' ? deleteHeader(values, req) : '';
  // headers contains credentials which should not be logged
  console.log('## fetch ' + (fetch.name.indexOf('fetchMock') !== -1 ? 'from MOCK ' : '') + apiUrl);
  return new _promise2.default(function (resolve, reject) {
    setTimeout(function () {
      reject(defaultErrors.timeout);
    }, timeout);
    fetch(apiUrl, (0, _extends3.default)({}, headers, {
      agent: __SERVER__ && __PROXY__ && __PROXY_IGNORE__.indexOf(_url2.default.parse(apiUrl).host) === -1 ? createAgent(apiUrl, __PROXY__) : undefined
    })).then(function (res) {
      if (!res.ok) {
        // response status code is out of the 200~299 range
        res.json().then(function (json) {
          reject(json.errors && json.errors.length ? json : defaultErrors.maintenance);
        }, function () {
          reject(defaultErrors.maintenance);
        });
      } else if (method === 'GET') {
        if (!retrieveBracket) {
          res.json().then(function (json) {
            if (json.errors && json.errors.length) {
              reject(json);
            } else {
              resolve(json);
            }
          }, function () {
            reject(res);
          });
        } else {
          res.text().then(function (text) {
            if (text !== 'error') {
              var resObject = JSON.parse(text.substring(text.indexOf('(') + 1, text.lastIndexOf(')')));
              if (resObject.successFlag === 'true') {
                resolve(resObject);
              } else {
                reject({ errors: [] });
              }
            } else {
              reject({ errors: [] });
            }
          }, function (err) {
            return reject(err);
          });
        }
      } else {
        res.json().then(function (json) {
          if (json.errors && json.errors.length) {
            reject(json);
          } else {
            resolve(json);
          }
        }, function () {
          return resolve(res);
        });
      }
    }, function (err) {
      // TODO: convert the error message to user friendly messages
      // network error
      console.error(apiUrl, err);
      reject(defaultErrors.timeout);
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-api-client.js
// module id = 124
// module chunks = 0